import SkillsCartography from './component';

export default SkillsCartography;
